import { render } from "./TermRecognition.vue?vue&type=template&id=31450350&scoped=true&ts=true"
import script from "./TermRecognition.vue?vue&type=script&lang=ts"
export * from "./TermRecognition.vue?vue&type=script&lang=ts"

import "./TermRecognition.vue?vue&type=style&index=0&id=31450350&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31450350"]])

export default __exports__